import React, {useCallback} from "react";
import {useParams} from "react-router-dom";
import {useTypedSelector} from "../../../redux/Hooks/storeSelectors";
import {selectMapLayerIdByEntityName} from "../../../redux/selectors/selectors";
import EntityManagerCleaner from "../../../components/Entities/EntityManagerCleaner";
import EntityEditor from "../../../components/Entities/EntityEditor";
import {ScenarioEventsEntityName} from "../../../api/types/types";


const EvEventEdit = () => {
    const entityName = ScenarioEventsEntityName.EvEvent;
    const {evEventId} = useParams<any>();
    const stopsLayerId = useTypedSelector((state) => selectMapLayerIdByEntityName(state, entityName));

    const onSaveFn = useCallback((entity: any) => {
        if (!evEventId) {
            return `../${entity.id}/edit`;
        }
    }, [evEventId]);

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityManagerCleaner entityName={entityName}>
            <EntityEditor
                entityId={evEventId!}
                entityName={entityName}
                layerId={stopsLayerId}
                presetProperty={'scenarioCasePreset'}
                getUrlOnSaveFn={onSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={!!evEventId}
            />
        </EntityManagerCleaner>
    )
}

export default EvEventEdit;